import { Info, Plus, Ticket } from '@phosphor-icons/react';
import React, { useState } from 'react';
import { Button, notify, InfoCard } from 'app/components';
import  Tickets  from './tickets';
import AddTicketDetails from './addTicketDetails';
import DeleteModal from './deleteModal';
import EditCancelModal from './editCancelModal';
import { createBusinessConfig, updateBusinessConfig } from '../../api';
import './style';
import { onShareWhatsapp } from '../../../../utils/commonUtils';

const AddTickets = ({title='Now, let’s add tickets', tickets, setTickets, isAdmin, allowNameEdit,
  readOnly, businessConfig, userData, saveEvent, eventData, priceBreakups, getPriceBreakup }) => {
  const [currentTicket, setCurrentTicket] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deletingTicket, setDeletingTicket] = useState(null);
  const [isTicketFormOpen, setIsTicketFormOpen] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [isEditCancelOpen, setIsEditCancelOpen] = useState(false);

  const handleSave = (ticket) => {
    const callback = () => {
      setIsTicketFormOpen(false);
      setCurrentTicket(null);
    };

    if(currentTicket){
      handleEdit(ticket, callback);
    }else{
      handleAdd(ticket, callback);
    }
  }
  
  const handleAdd = (ticket, callback) => {
    setTickets([...(tickets || []), ticket], callback);
  }
  const handleEdit = (updatedComponent, callback) => {
    setTickets(tickets?.map(ticket => ticket.id === updatedComponent.id ? updatedComponent : ticket ), callback);
  }

  const handleSoldStatus = (id) => {
    const updatedTickets = tickets?.map((ticket) => {
      if (ticket.id === id) {
        return { ...ticket, is_sold_out: !ticket?.is_sold_out };
      }

      return ticket;
    });

    setTickets(updatedTickets);
  }

  const handlePGchange = (isOwned) => {
    let newTickets = tickets.map(individualTicket => ({
        ...individualTicket,
        is_fee_owned_by_user: isOwned
    }));
    setTickets(newTickets);
  }

  const openModal = (ticket = null )=>{
    setCurrentTicket(ticket);
    setIsTicketFormOpen(true);
    setHasUnsavedChanges(false);
  }
  const closeModal = () => {
    if( hasUnsavedChanges){
      setIsEditCancelOpen(true);
    }
    else{
      setIsTicketFormOpen(false);
      setCurrentTicket(null);
      setHasUnsavedChanges(false);
    }
  }
  const handleEditCancelClose = () => {
    setIsEditCancelOpen(false);
  }
  const handleDiscardChanges = () =>{
    setIsEditCancelOpen(false);
    setIsTicketFormOpen(false);
    setCurrentTicket(null);
    setHasUnsavedChanges(false);
  }

  const handleSaleToggle = (id, ticketName) => {
    let isSale = false;
    const updatedTickets = tickets?.map((ticket) => {
      if (ticket.id === id) {
        isSale = !ticket?.is_active;
        return { ...ticket, is_active: !ticket?.is_active };
      }

      return ticket;
    });

    if (!updatedTickets?.filter((item) => item?.is_active)?.length) {
      notify('error', 'Atleast one ticket should be available for sale!', {duration: 2000,position: 'bottom-center'});
    } else {
      setTickets(updatedTickets, () => {
        const notificationMessage = isSale
        ? `${ticketName} is now available for sale!`
        : `${ticketName} is no longer available for sale!`;
  
        notify('success', notificationMessage, {duration: 2000,position: 'bottom-center'});
      });
    }
  };

  const handleDelete = (ticket) =>{
    setDeletingTicket(ticket);
    setIsDeleteModalOpen(true);
  };
  const handleDeleteModalClose = () => {
    setIsDeleteModalOpen(false);
    setDeletingTicket(null);
  };

  const handleConfirmDelete = () => {
    // Remove the ticket from the tickets array
    const updatedTickets = tickets?.filter(
      (ticket) => ticket.id !== deletingTicket.id,
    );
    setTickets(updatedTickets, () => handleDeleteModalClose());
  };

  const calculateRevenue = () => {
    return tickets?.reduce((total, ticket) => {
      const ticketPrice = parseFloat(ticket.price) || 0;
      const eventOrgFee = ticketPrice * 0.01;
      const gateWayFee = ticketPrice * 0.02;
      const orgMoney =
        !ticket.is_fee_owned_by_user
          ? ticketPrice - (gateWayFee + eventOrgFee)
          : ticketPrice - eventOrgFee;
      return total + orgMoney * ticket.quantity;
    }, 0);

  };
  const hasPaidTickets = () => {
    return tickets?.some((ticket) => parseFloat(ticket.price)) > 0;
  }
  const formatPrice = (price) => {
    return price.toFixed(0).replace(/(\d)(?=(\d\d)+\d$)/g, '$1,')
  }

  const handleRegisteredChange = (id) => {
    setTickets(null);
    const updatedBusinessConfig = {
      ...businessConfig,
      is_gst_registered: id === 'registered'
    };

    if (!userData?.business_config_id) {
      createBusinessConfig({
        business_config_id: 0,
        ...updatedBusinessConfig
      }).then((response) => {
        const newBusinessConfig = response?.data?.data || updatedBusinessConfig;
        saveEvent({
          ...eventData,
          business_config: newBusinessConfig
        });
      }).catch((error) => {
        console.error('Error creating business config:', error);
      });
    } else {
      updateBusinessConfig(
        userData?.business_config_id,
        updatedBusinessConfig
      ).then((response) => {
        const newBusinessConfig = response?.data?.data || updatedBusinessConfig;
        saveEvent({
          ...eventData,
          business_config: newBusinessConfig
        });
      }).catch((error) => {
        console.error('Error updating business config:', error);
      });
    }
    console.log(eventData);
  };

  const onClickGetInTouch = () => {
    onShareWhatsapp('9025082101', 'Hi! I would like to get GST registered in my state');
  };

  return (
    <div className="add-tickets flex flex-col flex-1 overflow-auto">

  {/* Header */}
  <div className={`flex justify-between items-center ${
    window.innerWidth <= 768 ? 'mb-4' : ''
  }`}>
    <div className="heading-36">{title}</div>

    {(!!tickets?.length && !readOnly && window.innerWidth > 768) && (
      <Button
        iconLeft={<Plus size={20} />}
        children="Add tickets"
        rounded={true}
        type="secondary"
        size="small"
        onClick={() => openModal()}
      />
    )}
  </div>

  {/* GST info */}
  {!businessConfig?.proof_data && (
    <InfoCard
      content={
        <div className="flex gap-5 items-center">
          Currently GST is applicable in TN, MH, KA & Goa. To add your state click get it touch.
          <Button
            className="shrink-0"
            type="primary-black"
            size="small"
            onClick={onClickGetInTouch}
            iconRight={<img src="/assets/images/wp.svg" alt="whatsapp"/>}
          >
            Get in Touch
          </Button>
        </div>
      }
      icon={<Info color="#101010" size={24} />}
    />
  )}

  {/* TICKETS LIST */}
  {tickets?.length ? (

    <div className="flex flex-col flex-1 justify-between gap-4 w-full overflow-auto">

      {/* Ticket cards */}
      <div className="flex flex-col gap-4 w-full flex-1 overflow-auto pr-2">
        {tickets?.map(ticket => (
          <Tickets
            key={ticket.id}
            ticket={ticket}
            onToggle={handleSaleToggle}
            onEdit={() => openModal(ticket)}
            onDelete={() => handleDelete(ticket)}
            onSoldStatusToggle={handleSoldStatus}
            disableToggle={readOnly}
            allowDelete={allowNameEdit || isAdmin}
          />
        ))}
      </div>

      {/* MOBILE Add Ticket floating bottom button */}
      {(!!tickets?.length && !readOnly && window.innerWidth <= 768) && (
        <div className="flex justify-center mt-2 pb-4">
          <Button
            iconLeft={<Plus size={20} />}
            children="Add tickets"
            rounded={true}
            type="primary-black"
            size="small"
            onClick={() => openModal()}
          />
        </div>
      )}
    </div>

  ) : (
    // EMPTY STATE
    <>
      <div className="field-container bg-grey-5 flex-1 justify-center px-4">
        <div className="ticket shadow-flat">
          <Ticket size={32} />
        </div>

        <div className="text-18 mt-2 mb-3">
          Add your first ticket category.
        </div>

        <Button
          iconLeft={<Plus size={20} />}
          children="Add tickets"
          rounded={true}
          type="primary-black"
          size="small"
          onClick={() => openModal()}
        />
      </div>
    </>
  )}

  {/* MODALS */}
  {isTicketFormOpen && (
    <AddTicketDetails
      isOpen={isTicketFormOpen}
      ticket={currentTicket}
      onPGchange={handlePGchange}
      onSave={handleSave}
      onClose={() => closeModal(hasUnsavedChanges)}
      existingTickets={tickets}
      setHasUnsavedChanges={setHasUnsavedChanges}
      isAdmin={isAdmin}
      allowNameEdit={allowNameEdit}
      priceBreakups={priceBreakups}
      getPriceBreakup={getPriceBreakup}
    />
  )}

  {deletingTicket && (
    <DeleteModal
      isOpen={isDeleteModalOpen}
      onCancel={handleDeleteModalClose}
      onConfirm={handleConfirmDelete}
      ticketName={deletingTicket.option_value_1}
    />
  )}

  {isEditCancelOpen && (
    <EditCancelModal
      isOpen={isEditCancelOpen}
      onCancel={handleEditCancelClose}
      onConfirm={handleDiscardChanges}
      handleBackEdit={handleEditCancelClose}
    />
  )}
</div>

  );
};

export default AddTickets;
